import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import arrowIcon from "../../../images/right-arrow.png";
import { parseHtml } from "../../../helpers";
import { useSearchResultsStore } from "../../../services/store";

export default function FiltersSimple({ classes, introText, loadData }) {
  const [query, updateQuery] = useState();
  const [radius, updateRadius] = useState("5");

  const {
    searchQuery,
    setSearchQuery,
    searchRadius,
    setSearchRadius,
  } = useSearchResultsStore();

  function handleSubmit(e) {
    e.preventDefault();

    const data = {
      query,
      searchRadius,
      requireFood: false,
      requireAccommodation: false,
      requireDogFriendly: false,
      requireBeerGarden: false,
    };

    loadData(data);
  }

  return (
    <form className={classes.Form} onSubmit={handleSubmit}>
      <Grid container direction="row">
        <Grid item xs={12} md={6}>
          <h3 className={classes.Legend}>Find a Pub</h3>
          <p className={classes.Intro}>{parseHtml(introText)}</p>
        </Grid>
        <Grid item xs={12} md={6}>
          <div className={classes.Fields} data-simple="true">
            <div
              className={`${classes.Field} ${classes.Name}`}
              role="search"
              data-simple="true"
            >
              <label className={classes.Label} htmlFor="name">
                Search by
              </label>
              <input
                className={classes.Input}
                type="search"
                id="name"
                name="query"
                placeholder="Pub Name or Town or Postcode"
                autoComplete="off"
                defaultValue={searchQuery ?? query}
                onChange={e => {
                  updateQuery(e.target.value);
                  setSearchQuery(e.target.value);
                }}
              />
            </div>
            <div className={classes.Field} data-simple="true">
              <label className={classes.Label} htmlFor="radius">
                Radius
              </label>
              <select
                className={`${classes.Input} ${classes.Radius}`}
                name="radius"
                // value={radius}
                // onBlur={e => updateRadius(e.target.value)}
                // onChange={e => updateRadius(e.target.value)}
                value={searchRadius}
                onBlur={e => {
                  setSearchRadius(e.target.value);
                }}
                onChange={e => {
                  setSearchRadius(e.target.value);
                }}
              >
                {[5, 10, 15, 20, 25, 50, 100].map((r, i) => (
                  <option value={r} key={i}>{`${r} Miles`}</option>
                ))}
              </select>
            </div>
            <div
              className={`${classes.Field} ${classes.Submit}`}
              data-simple="true"
            >
              <button className={classes.Button}>
                search
                <img src={arrowIcon} alt="Search" width={14} height={15} />
              </button>
            </div>
          </div>
        </Grid>
      </Grid>
    </form>
  );
}
